import apiClient from './apiClient';

export type AttendanceMethod = 'badge' | 'manual';

export interface AttendanceRecord {
  id: string;
  workerId: string;
  projectId: string;
  attendanceDate: string;
  scanInAt: string;
  scanOutAt?: string | null;
  method: AttendanceMethod;
  recordedBy?: string | null;
  clientUuid?: string | null;
  notes?: string | null;
  worker?: {
    id: string;
    name: string;
    badgeCode?: string | null;
    teamId?: string | null;
    trade?: string | null;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface AttendancePayload {
  workerId: string;
  projectId: string;
  attendanceDate: string;
  scanInAt?: string | null;
  scanOutAt?: string | null;
  method?: AttendanceMethod;
  clientUuid?: string | null;
  notes?: string | null;
}

const unwrap = <T>(response: any): T => {
  const body = response?.data ?? response;
  return Object.prototype.hasOwnProperty.call(body, 'data') ? body.data as T : body as T;
};

class AttendanceService {
  async list(params: { projectId: string; attendanceDate?: string; teamId?: string }): Promise<AttendanceRecord[]> {
    return unwrap<AttendanceRecord[]>(await apiClient.get('/attendance', { params }));
  }

  async record(payload: AttendancePayload): Promise<AttendanceRecord> {
    return unwrap<AttendanceRecord>(await apiClient.post('/attendance', payload));
  }
}

export default new AttendanceService();
